import * as yup from 'yup';
export const FIELD_REQUIRED_ERROR = 'This field is required.';
export const FILE_FIELD_REQUIRED_ERROR = 'Please upload required documentation.';
export const MAX_DIGITS_ERROR = 'Field length should have no more than 16 digits.';
export const createValidationSchema = (id, options) => {
    const readOnly = options === null || options === void 0 ? void 0 : options.readOnly;
    const optional = options === null || options === void 0 ? void 0 : options.optional;
    return yup.object({
        [id]: yup.array().of(yup.lazy((field) => {
            var _a;
            let value;
            const { type, usageLevel } = field;
            const readOnlyField = (_a = options === null || options === void 0 ? void 0 : options.readOnlyFields) === null || _a === void 0 ? void 0 : _a[field.propertyDefinitionId];
            const allowRequired = !readOnly && !readOnlyField && !optional && usageLevel === 'REQUIRED';
            switch (type) {
                case 'NUMERIC':
                    value = yup
                        .number()
                        .nullable()
                        .transform((_, val) => (val === 0 || val ? Number(val) : null))
                        .test('len', MAX_DIGITS_ERROR, (number) => {
                        return (Object.is(number, null) || number.toString().length <= 16);
                    });
                    if (allowRequired) {
                        value = value.required(FIELD_REQUIRED_ERROR);
                    }
                    break;
                case 'PICK_LIST':
                    value = yup
                        .number()
                        .nullable()
                        .transform((_, val) => (val === 0 || val ? Number(val) : null));
                    if (allowRequired) {
                        value = value.required(FIELD_REQUIRED_ERROR);
                    }
                    break;
                case 'FILE_UPLOAD':
                    value = yup
                        .object({
                        name: yup.string(),
                        file: yup.mixed().nullable(),
                        uuid: yup.string().optional(),
                    })
                        .default(undefined);
                    if (allowRequired) {
                        value = value.required(FILE_FIELD_REQUIRED_ERROR);
                    }
                    break;
                case 'MULTIPLE_CHECKBOXES':
                    value = yup.array().of(yup.mixed());
                    if (allowRequired) {
                        value = value
                            .min(1, FIELD_REQUIRED_ERROR)
                            .required(FIELD_REQUIRED_ERROR);
                    }
                    break;
                default:
                    value = yup.string().trim();
                    if (allowRequired) {
                        value = value.required(FIELD_REQUIRED_ERROR);
                    }
                    break;
            }
            const properties = {
                propertyDefinitionId: yup.number(),
                programId: yup.number().optional(),
                type: yup.string(),
                name: yup.string(),
                usageLevel: yup.string(),
                order: yup.number(),
                items: yup.array().optional(),
                value,
            };
            return yup.object(properties);
        })),
    });
};
